/**
 * @file: StageCore对外接口
 * @author: xiaolong.huang@dmall.com
 */

import { StageEvent as Message } from '../message/index';
import Utils from '../utils/util';
import __Config__ from '../config/index';
import cookie from '../utils/cookie';
import { getTargetCubeAllData } from '../frontCubeData/index';
import { useStageCore } from '../toolkit/index';
import { getCubeValue } from './getCubeValue';
import { updateCubeList } from './updateCubeList';
import { updatePaper } from './updatePaper';
import { jump } from './version';
import { modifyCube } from './modifyCube';
import {
    getSavePaperData,
    findParentIdByCubeId,
    findCubeByType,
    findCubeReader,
    findCubeInStage,
    findChildCubeIds
} from './cubeQuery';
import {
    isGoods,
    isBafflePlate,
    isTextarea
} from './cubeInfo';
import { clearAllSelect } from './select';
import { addNoneTag } from './addNoneTag';
import { getPhysicsCoordinate, getLogicCoordinate, getPaintCoordinate } from './codiSystem';

let Tool: FreeObjMap = {
    cookie,
    useStageCore,
    getTargetCubeAllData,
    getSavePaperData,
    updatePaper,
    clearAllSelect,
    getCubeValue,
    updateCubeList,
    findParentIdByCubeId,
    getPhysicsCoordinate,
    getLogicCoordinate,
    getPaintCoordinate,
    findCubeByType,
    findCubeReader,
    findCubeInStage,
    findChildCubeIds,
    addNoneTag,
    jump,
    isGoods,
    isBafflePlate,
    isTextarea,
    modifyCube
};

// config读值白名单
const getModuleNameWhiteList: Array<string> = ['freezer', 'base'];
const getKeyWhiteList: Array<string> = ['cabinetTransLayout', 'auth', 'renderFace'];

// config写值白名单
const setModuleNameWhiteList: Array<string> = ['freezer', 'base'];
const setKeyWhiteList: Array<string> = ['cabinetTransLayout', 'auth', 'renderFace'];
let Config: FreeObjMap = {
    get(params: ConfigGetParams): any {
        if (!getModuleNameWhiteList.includes(params.moduleName) || !getKeyWhiteList.includes(params.key)) {
            return null;
        }
        let temp: FreeObjMap = {
            value: __Config__.get({
                moduleName: params.moduleName,
                key: params.key
            })
        };

        // 获取内部config，值深拷贝，斩断引用关系
        let result: FreeObjMap = Utils.deepCopy(temp);

        return result.value;
    },

    set(params: ConfigSetParams): void {
        if (!setModuleNameWhiteList.includes(params.moduleName) || !setKeyWhiteList.includes(params.key)) {
            return null;
        }

        __Config__.set({
            moduleName: params.moduleName,
            key: params.key,
            value: params.value
        });
    }
};

export { Message, Tool, Config };
